import firebase from "firebase";

const config = {
  apiKey: "AIzaSyC94c6EVtlR08rEuYjaPUiVbq0Qnh1lyfU",
  authDomain: "test-569da.firebaseapp.com",
  databaseURL: "https://test-569da.firebaseio.com",
  projectId: "test-569da",
  storageBucket: "test-569da.appspot.com",
  messagingSenderId: "602519511975"
};

const fb = firebase.initializeApp(config);

export default fb;
